import styled from 'styled-components'

import {
  columns,
  ColumnsProps,
  flexbox,
  FlexboxProps,
  gap,
  GapProps,
  grid,
  GridLayoutProps,
  space,
  SpaceProps,
} from '../../themes'

export interface BaseGridLayoutProps
  extends SpaceProps,
    GridLayoutProps,
    FlexboxProps,
    GapProps,
    ColumnsProps {
  width?: string | number
}

export const BaseGrid = styled.div<BaseGridLayoutProps>`
  ${space}
  ${grid}
  ${flexbox}
  ${gap}
  ${columns}
  display: grid;
  width: ${({ width }) =>
    width ? (typeof width === 'number' ? `${width}px` : width) : 'auto'};
`
